namespace GeniuzPOS.Product {
    export enum ActiveFg {
        UnActive = 0,
        IsActive = 1
    }
    Serenity.Decorators.registerEnumType(ActiveFg, 'GeniuzPOS.Product.ActiveFg');
}
